/**
 * # config
 * Constant in the sharedModule.
 *
 * * spynlSubdomain - sibling domain for spynl backend
 */
export interface IConfig {
  spynlSubdomain: string;
  spynlServices: string;
}

export const ConfigProvider: { provide: string; useValue: IConfig } = {
  provide: 'config',
  useValue: {
    spynlSubdomain: 'spynl',
    spynlServices: 'spynl-services',
  },
};
